import { saveFile } from 'data/saveFile';
import { useMutation } from 'query';
import { download } from 'scenes/FinancePage/IO/data/queryKeyFactory';
import { downloadAttachment } from 'scenes/FinancePage/IO/sources';

export const useDownloadAttachment = () => {
  const approveMutation = useMutation(download(), downloadAttachment);

  const handleAction = async ({
    id,
    url,
    fileName,
  }: {
    id: number;
    url: string;
    fileName: string;
  }) => {
    let fileData = null;

    if (id) {
      fileData = await approveMutation.mutateAsync({ id });
    } else if (url) {
      window.open(url, '_blank')?.focus();
    }

    await saveFile({ fileData, fileName: fileName || url });
  };

  return [handleAction, approveMutation];
};
